<template>
	<div
		v-if="items.results.length > 0"
		class="card"
	>
		<div class="card-header py-3 pr-3 bold text-uppercase text-dark d-flex align-items-center">
			<a-badge
				:count="items.total"
				:overflow-count="99"
				:offset="[15,0]"
			>
				<fa-icon
					icon="file-invoice"
					class="mr-2"
				/> Facturas
			</a-badge>

			<div class="ml-auto" />

			<a-tooltip placement="top">
				<template slot="title">
					<fa-icon
						:icon="['fas', 'external-link-alt']"
						class="mr-2"
					/> Ver más
				</template>
				<a-button
					v-if="haveMore"
					class="mr-2"
					@click="$router.push({name: 'facturas', query: {empresa: id}})"
				>
					<fa-icon :icon="['fas', 'external-link-alt']" />
				</a-button>
			</a-tooltip>

			<a-tooltip placement="top">
				<template slot="title">
					<fa-icon
						:icon="['fas', 'sync-alt']"
						class="mr-2"
					/> Refrescar
				</template>
				<a-button @click="list">
					<fa-icon
						:icon="['fas', 'sync-alt']"
						:spin="loading"
					/>
				</a-button>
			</a-tooltip>
		</div>

		<div class="card-body p-0">
			<table class="table table-striped mb-0">
				<tbody>
					<tr
						v-for="(item,index) in items.results"
						:key="index"
					>
						<td :class="$style.icon">
							<a-tooltip placement="left">
								<template
									v-if="!item.FacturaPDF"
									slot="title"
								>
									No se ha generado el PDF
								</template>
								<img
									:class="item.FacturaPDF ? 'pointer': 'img-gray'"
									src="@/application/assets/images/icons/invoice.svg"
									@click="openPDF(item)"
								>
							</a-tooltip>
						</td>
						<td :class="$style.info">
							<div
								:class="item.FacturaPDF ? 'pointer' : ''"
								@click="openPDF(item)"
							>
								<h5>
									{{ item.FacturaTotal | price }}€
								</h5>
								<span>
									<fa-icon
										:icon="['fas', 'qrcode']"
									/> {{ item.FacturaSerie }}
								</span>
							</div>
						</td>
						<td :class="$style.email">
							<g-email
								:value="item"
								size="small"
							/>
						</td>
						<td :class="$style.status">
							<a-tooltip
								placement="top"
							>
								<template slot="title">
									{{ $gestios.$utils.getValue('facturas','FacturaEstado', item.FacturaEstado) }}
								</template>

								<fa-icon
									v-if="item.FacturaEstado===0"
									:icon="['far', 'clock']"
									class="mr-2 text-warning"
								/>
								<fa-icon
									v-else-if="item.FacturaEstado===2"
									:icon="['far', 'check-circle']"
									class="mr-2 text-success"
								/>
								<fa-icon
									v-else-if="item.FacturaEstado===1"
									:icon="['far', 'sad-tear']"
									class="mr-2 text-danger"
								/>
							</a-tooltip>
						</td>
						<td :class="$style.actions">
							<g-item-actions
								app="facturas"
								:item="item"
								:text="false"
								:loading="working === item._EntityId"
								mode="dropdown"
								@edit="$router.push({name: 'facturas_edit', params: {id: $event._EntityId}})"
							>
								<template slot="top">
									<!-- Cambiar estado -->
									<a-menu-item
										key="5"
										:class="item.FacturaEstado === 0 ? 'text-muted': 'text-warning'"
										@click="setStatus(item._EntityId, 0, 'pendiente')"
									>
										<fa-icon
											:icon="['far','clock']"
											class="mr-2"
										/> Pendiente
									</a-menu-item>

									<!-- Cambiar estado -->
									<a-menu-item
										key="4"
										:class="item.FacturaEstado === 2 ? 'text-muted': 'text-success'"
										@click="setStatus(item._EntityId, 2, 'pagada')"
									>
										<fa-icon
											:icon="['fas','check']"
											class="mr-2"
										/> Pagada
									</a-menu-item>

									<!-- Cambiar estado -->
									<a-menu-item
										key="3"
										:class="item.FacturaEstado === 1 ? 'text-muted': 'text-danger'"
										@click="setStatus(item._EntityId, 1, 'impagada')"
									>
										<fa-icon
											:icon="['far','sad-tear']"
											class="mr-2"
										/> Impagada
									</a-menu-item>

									<a-menu-divider />

									<!-- Enviar email -->
									<a-menu-item
										v-if="item.FacturaPDF"
										key="2"
										:disabled="working === item._EntityId"
										@click="mailerScope = item"
									>
										<fa-icon
											:icon="['far','paper-plane']"
											class="mr-2"
										/> Enviar email
									</a-menu-item>

									<!-- Crear PDF -->
									<a-menu-item
										key="1"
										:disabled="working === item._EntityId"
									>
										<a-popconfirm
											v-if="$gestios.items('facturas').auth({
												scopes: [`set.mine`, `set`],
												strict: false,
												item
											})"
											title="¿Se regenerará el PDF de la factura. ¿Estas seguro?"
											@confirm="() => createPDF(item)"
										>
											<fa-icon
												:icon="['fas','file-pdf']"
												class="mr-2"
											/>
											Generar PDF
										</a-popconfirm>
									</a-menu-item>
								</template>
							</g-item-actions>
						</td>
					</tr>
				</tbody>
			</table>

			<mailer
				:item="mailerScope"
				view="facturasList"
				@close="mailerScope = null"
			/>
		</div>
	</div>
</template>

<script>
import mailer from '@/application/views/facturas/mailer';
import facturasMX from '@/application/helpers/facturas';

export default {
	name: 'InvoiceList',
	components: { mailer },
	props: {
		id: {
			type: Number,
			default: 0
		},
		limit: {
			type: Number,
			default: 6
		}
	},
	data() {
		return {
			loading: false,
			working: false,
			mailerScope: null,
			e404: false
		};
	},
	computed: {
		view() {
			return `facturas_${this.id}`;
		},
		items() {
			const results = this.$gestios.$cache.view(this.view);
			if (results) return results;
			return {
				results: [],
				total: 0
			};
		},
		haveMore() {
			if (this.items.total > this.limit) return true;
			return false;
		}
	},
	watch: {
		id() {
			this.list();
		}
	},
	created() {
		this.list();
	},
	methods: {
		async list() {
			this.loading = true;

			let filters = null;
			if (this.id > 0) {
				filters = [{
					_ParentOperator: 'AND',
					_Operator: 'AND',
					Fields: {
						Empresa: {
							type: 'number',
							lig: '=',
							value: this.id
						}
					}
				}];
			}

			const result = await this.$gestios.items('facturas').list({
				view: this.view,
				page: 1,
				limit: this.limit,
				order: {
					FacturaFecha: 'desc'
				},
				filters,
				reset: true
			});

			if (!result.ok) {
				this.e404 = true;
			}

			this.loading = false;
		},
		async setStatus(id, value, text) {
			this.working = id;
			await facturasMX.setStatus(id, value, text);
			this.working = null;
		},
		async createPDF(item) {
			this.working = item._EntityId;
			await facturasMX.renderPDF(item);
			this.working = null;
		},
		openPDF(item) {
			if (item.FacturaPDF) {
				window.open(item.FacturaPDF.Link, '_blank');
			}
		}
	}
};
</script>

<style lang="scss" module>
	.info, .actions, .icon, .status, .email{
		vertical-align: middle !important;
	}

	.icon{
		width: 40px;

		img{
			width: 40px;
		}
	}

	.info{
		display: flex;
		align-items: center;

		span{
			color: $gray-5;
			font-size: 12px;

			svg{
				font-size: 12px;
			}
		}

		h5{
			margin-top:3px;
			font-size: 16px;
			line-height: 16px;
			margin: 0;
		}
	}

	.email{
		text-align: right;
		padding-right: 0 !important;
	}

	.actions{
		width: 60px;
		text-align: right;
		padding-left: 0 !important;
	}

	.status{
		width: auto;
		text-align: right;
		padding-left: 0 !important;
		padding-right: 0 !important;
	}
</style>
